<script>
import { FormModel } from '@/components/global/form';
import { scrollToError } from '../../utilities/helpers';

export default {
    name: 'CcConfirmationForm',

    props: {
        initialData: null,
        documentSignInitiated: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            loading: false,
            model: null,
            timeoutId: null,
            iframeUrl: null,
        };
    },

    created() {
        this.model = new FormModel(this.initialData);
    },

    mounted() {
        if (!this.documentSignInitiated) {
            return;
        }

        this.statusCheck();
    },

    methods: {
        async submit() {
            if (this.loading) {
                return;
            }
            this.loading = true;

            try {
                if (this.timeoutId) {
                    window.clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }

                const response = await this.$http.post('', this.model.data);
                if (response.data.data.confirmed) {
                    window.location = response.data.data.redirect;
                } else {
                    this.iframeUrl = response.data.data.redirect;
                    this.statusCheck();
                }
            } catch (e) {
                this.model.$e.updateFromResponse(e);
                scrollToError();
                this.$sentyReporting.report(e);

                this.loading = false;
            }
        },

        closeModal() {
            this.iframeUrl = null;
        },

        statusCheck() {
            if (this.timeoutId) {
                return;
            }

            const callback = async () => {
                try {
                    const response = await this.$http.get('/legal-entity/confirmation/check');

                    if (response.data.data.confirmed) {
                        window.clearTimeout(this.timeoutId);
                        this.timeoutId = null;

                        window.location = response.data.data.redirect;
                    }
                } catch (e) {
                    this.timeoutId = window.setTimeout(callback, 3000);
                    this.$sentyReporting.report(e);
                }
            };

            callback();
        },
    },
};
</script>
